import { renderSlide } from './utils';
import { Carousel, EmptyCarousel } from '../../components/Carousel';
import { useGallery } from '../../hooks';

export const CarouselContainer = () => {
  const { photos } = useGallery();

  if (!photos.length) {
    return <EmptyCarousel />;
  }

  return <Carousel slides={photos.map(renderSlide)} />;
};
